<template>
    <div class="ShowCartStickyButton">
        <v-btn
            :to="{ name: 'cart' }"
            class="ShowCartStickyButton-button font-weight-bold"
            color="primary"
            size="x-large"
            variant="flat"
        >
            {{ $t('cart:go_to_cart') }}
            <div class="ShowCartStickyButton-quantity">
                {{ cartQuantity }}
            </div>
        </v-btn>
    </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed } from 'vue'

const store = useStore()

const cartQuantity = computed(() => store.getters.getCartProductsQuantity)
</script>

<style lang="scss" scoped>
@import 'globalScss';

.ShowCartStickyButton {
    padding: $s4;
    background: $color-lightest;

    &-button {
        position: relative;
        width: 100%;
        font-size: $font-small;
    }

    :deep(.v-btn__content) {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: $s2;
    }

    &-quantity {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: $s2;
        right: $s2;
        min-width: 36px;
        height: 36px;
        padding: $s1;
        border-radius: $border-radius-small;
        background: $color-lightest;
        font-size: $font-xsmall;
        color: $color-brandPrimary;
    }
}
</style>
